'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _lodash = require('lodash');

var _dialogButton = require('../models/dialog/dialogButton');

var _dialogButton2 = _interopRequireDefault(_dialogButton);

var _dialogConfig = require('../models/dialog/dialogConfig');

var _dialogConfig2 = _interopRequireDefault(_dialogConfig);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DialogService = function () {
  function DialogService($ngConfirm) {
    "ngInject";

    (0, _classCallCheck3.default)(this, DialogService);
    this.$ngConfirm = $ngConfirm;
  }

  (0, _createClass3.default)(DialogService, [{
    key: 'single',
    value: function single(dialogConfig, dialogButton) {
      return this.$ngConfirm({
        title: dialogConfig.title,
        content: dialogConfig.content,
        contentUrl: dialogConfig.contentUrl,
        type: dialogConfig.type,
        typeAnimated: true,
        buttons: {
          ok: {
            text: dialogButton.text,
            btnClass: dialogButton.btnClass,
            action: function action(scope, button) {
              if (dialogButton.callback) {
                return dialogButton.callback(scope, button);
              }
              return true;
            }
          }
        }
      });
    }
  }, {
    key: 'double',
    value: function double(dialogConfig, dialogButton1, dialogButton2) {
      return this.$ngConfirm({
        title: dialogConfig.title,
        content: dialogConfig.content,
        contentUrl: dialogConfig.contentUrl,
        type: dialogConfig.type,
        typeAnimated: true,
        buttons: {
          button1: {
            text: dialogButton1.text,
            btnClass: dialogButton1.btnClass,
            action: function action(scope, button) {
              if (dialogButton1.callback) {
                return dialogButton1.callback(scope, button);
              }
              return true;
            }
          },
          button2: {
            text: dialogButton2.text,
            btnClass: dialogButton2.btnClass,
            action: function action(scope, button) {
              if (dialogButton2.callback) {
                return dialogButton2.callback(scope, button);
              }
              return true;
            }
          }
        }
      });
    }
  }, {
    key: 'triple',
    value: function triple(dialogConfig, dialogButton1, dialogButton2, dialogButton3) {
      return this.$ngConfirm({
        title: dialogConfig.title,
        content: dialogConfig.content,
        contentUrl: dialogConfig.contentUrl,
        type: dialogConfig.type,
        typeAnimated: true,
        buttons: {
          button1: {
            text: dialogButton1.text,
            btnClass: dialogButton1.btnClass,
            action: function action(scope, button) {
              if (dialogButton1.callback) {
                return dialogButton1.callback(scope, button);
              }
              return true;
            }
          },
          button2: {
            text: dialogButton2.text,
            btnClass: dialogButton2.btnClass,
            action: function action(scope, button) {
              if (dialogButton2.callback) {
                return dialogButton2.callback(scope, button);
              }
              return true;
            }
          },
          button3: {
            text: dialogButton3.text,
            btnClass: dialogButton3.btnClass,
            action: function action(scope, button) {
              if (dialogButton3.callback) {
                return dialogButton3.callback(scope, button);
              }
              return true;
            }
          }
        }
      });
    }
  }, {
    key: 'error',
    value: function error(message) {
      return this.single(_dialogConfig2.default.red(message), _dialogButton2.default.ok());
    }
  }]);
  return DialogService;
}();

exports.default = DialogService;


// WEBPACK FOOTER //
// ./client/app/common/services/dialogService.js